module.exports = __webpack_public_path__ + "assets/14acd35ca297bc022a450a51836f6fb6.png";